import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const ConditionalImage = ({ src, alt }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const img = new Image();

    img.onload = () => {
      setImageLoaded(true);
    };

    img.onerror = () => {
      setImageError(true);
    };

    img.src = src;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [src]);

  return (
    <div>
      {!imageError && (
        <img
          src={src}
          alt={alt}
          style={{ display: imageLoaded ? 'block' : 'none' }}
          loading="lazy"
        />
      )}
    </div>
  );
};

ConditionalImage.defaultProps = {
  src: '',
  alt: ''
};

ConditionalImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string
};

export default ConditionalImage;
